import React from "react";
import { ShowMovie } from "pages";

const ShowMovieRoute = () => {
  return (
    <>
      <ShowMovie />
    </>
  );
};

export default ShowMovieRoute;
